import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getFocusRingBoxShadow } from '@/src/components/focusring/focusring';

export const flowLink: Components<Theme>['MuiLink'] = {
  defaultProps: {
    underline: 'always',
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      // radius for the focus ring
      borderRadius: '2px',
      // focused state
      '&.Mui-focusVisible': {
        outline: 'none',
        boxShadow: getFocusRingBoxShadow(theme),
      },
      textDecorationColor: 'currentColor',
      // brand green, default
      ...(ownerState.color === 'primary' && {
        color: theme.palette.brand.primary,
        '&:hover': {
          color: theme.palette.brandHover.primary,
        },
      }),
      // electric green, dark background
      ...(ownerState.color === 'secondary' && {
        color: theme.palette.brand.secondary,
        '&:hover': {
          color: theme.palette.brand.quarternary,
        },
      }),
      // bold highlighted
      ...(ownerState.color === 'textPrimary' && {
        fontWeight: '400',
        '&, &:hover': {
          color: theme.palette.text.primary,
        },
      }),
      // unsupported @mui variants in Flow palette
      ...(ownerState.color === 'textSecondary' && {
        color: theme.palette.secondary.main,
        '&:hover': {
          color: theme.palette.secondary.dark,
        },
      }),
      ...(ownerState.color === 'textDisabled' && {
        color: theme.palette.disabled.primary,
        '&:hover': {
          color: theme.palette.disabled.tertiary,
        },
      }),
      // visited style, not activated by default due to very aggressive and dominant styling
      //  which affects buttons and other components
      ...(!!ownerState.visited && {
        '&:visited': {
          textDecorationColor: theme.palette.onSurface.os600,
          color: theme.palette.onSurface.os600,
          ...(ownerState.color === 'secondary' && {
            textDecorationColor: theme.palette.onSurface.os200,
            color: theme.palette.onSurface.os200,
          }),
        },
      }),
      // semantic
      ...(ownerState.color === 'error' && {
        fontWeight: '400',
        color: theme.palette.error.main,
        '&:hover': {
          color: theme.palette.error.dark,
        },
      }),
      ...(ownerState.color === 'warning' && {
        fontWeight: '400',
        color: theme.palette.warning.main,
        '&:hover': {
          color: theme.palette.warning.dark,
        },
      }),
      ...(ownerState.color === 'info' && {
        fontWeight: '400',
        color: theme.palette.info.main,
        '&:hover': {
          color: theme.palette.info.dark,
        },
      }),
      ...(ownerState.color === 'success' && {
        fontWeight: '400',
        color: theme.palette.success.main,
        '&:hover': {
          color: theme.palette.success.dark,
        },
      }),
    }),
    underlineHover: {
      textDecorationThickness: '1px',
      textUnderlineOffset: '2px',
    },
    underlineAlways: {
      textDecorationThickness: '1px',
      textUnderlineOffset: '2px',
    },
  },
};
